export class SearchResults<T> {
  page!: number;
  pageSize!: number;
  itemsCount!: number;
  items!: Array<T>;

  static fromJSON<T>(json: any, type: any): SearchResults<T> {
    const instance = new SearchResults<T>();
    instance.page = json.page;
    instance.pageSize = json.pageSize;
    instance.itemsCount = json.itemsCount;
    instance.items = [];
    json.items.forEach((element: any) => {
      instance.items.push(type.fromJSON(element));
    });
    return instance;
  }

  public fromJSONItems(jsonItems: [any], type: any): void {
    this.items = [];
    jsonItems.forEach((element) => this.items.push(type.fromJSON(element)));
  }
}
